import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

// Custom Mammoth icon (mascot) - extracted from Font Awesome Kit
export const faSolidMammoth: IconDefinition = {
  prefix: "fas",
  iconName: "solid-mammoth" as any,
  icon: [
    512,
    512,
    [],
    "e04e",
    "M323.5 76.8l33.1 0c18.3 0 33.1 16.5 33.1 36.8c0 5.1-3.7 9.2-8.3 9.2s-8.3-4.1-8.3-9.2c0 5.1-3.7 9.2-8.3 9.2s-8.3-4.1-8.3-9.2c0 5.1-3.7 9.2-8.3 9.2s-8.3-4.1-8.3-9.2c0 5.1-3.7 9.2-8.3 9.2s-8.3-4.1-8.3-9.2c0 5.1-3.7 9.2-8.3 9.2s-8.3-4.1-8.3-9.2c0-20.3 14.8-36.8 33.1-36.8zm29.4 194.1c.2 0 .5 0 .7 0l14.5 0c3.8 0 6.1 3.1 6.1 7c0 27.5 22.7 41.6 49.6 41.6s48.7-22.3 48.7-49.9c0-3.9 3.1-7.1 6.9-7.1s7 3.2 7 7.1l0 7.1c0 35.1-24.8 64.3-57.4 70.2c-.4 36.2-29.9 63.5-66.2 63.5c-27.4 0-50.2-19.4-50.2-54.3l38.8 0c0 5.6 0 11.6 7.7 11.6c7.8 0 7.8-7.1 7.8-11.6l0-25.6c-12.1-10.8-19.5-26.3-19.5-45.5l0-6.5-50.7 0 0 147.3 0 7.8-100.2 0-.1-68.8c0-9.1-7.6-16.6-16.9-16.6l-53.2 0 0 77.4 0 .1 0 7.8-100.7 0 0-153.6c0-91.4 68-165.5 161.6-165.5l.1-2.4c1.3-17.5 19.2-27.9 37.1-27.9l16.1 0c17.9 0 33 10.4 34.3 27.9l.1 .8 0 .8 0 .8 .1 .9 9.7 20.5 104.9-.2 13.3-20.3 1 0c18.3 0 25 13.9 25 32.2l0 155c-26.4-.2-37.7-12.2-37.7-39.5c0-3.9-5-8.1-8.8-8.1l-43.2 0c-2.6 0-10-3.6-15.4-8.5c-5.5-5.1-8.9-12.2-10-14.5l-.2-.4c-.7-1.5-4.5-4.3-8.5-2.6c-4.3 1.8-4.3 7.9-4.3 7.9c1.7 6.2 3.4 12.3 9.4 18.5s8.5 8.8 15.4 12.3s13.7 3.2 13.7 3.2l13.6 0zM336.8 205a18.5 18.5 0 1 0 37 0 18.5 18.5 0 1 0 -37 0z"
  ]
};

// Custom Translate icon - extracted from Font Awesome Kit
export const faTranslate: IconDefinition = {
  prefix: "fas",
  iconName: "translate" as any,
  icon: [
    512,
    512,
    [],
    "e02f",
    "M191.2 51.2c11.3 0 20.5 9.2 20.5 20.5l0 19.3 53.8 0c.2 0 .5 0 .7 0l44.4 0c11.3 0 20.5 9.2 20.5 20.5s-9.2 20.5-20.5 20.5l-27.9 0c-11.5 53.2-34.1 102.2-65.3 144.5c3 3.4 6.1 6.7 9.3 10c7.9 8.1 7.6 21.1-.5 29s-21.1 7.6-29-.5c-2.1-2.1-4.1-4.3-6.1-6.5c-31.3 33.9-68.6 62.1-110.4 82.9c-10.1 5-22.4 .9-27.5-9.2s-.9-22.4 9.2-27.5c38.9-19.4 73.6-46 102.2-78.1c-17.6-23.8-32.4-49.7-44.1-77.3c-4.4-10.4 .5-22.4 10.9-26.8s22.4 .5 26.8 10.9c8.9 21.1 19.9 41 32.7 59.7c22.8-33.2 39.8-70.6 49.6-110.9L71.7 132c-11.3 0-20.5-9.2-20.5-20.5s9.2-20.5 20.5-20.5l99 0 0-19.3c0-11.3 9.2-20.5 20.5-20.5zM330.5 210.5c7.8 0 14.8 4.4 18.3 11.3l69.5 139c.1 .3 .3 .5 .4 .8l29.7 59.3c5.1 10.1 1 22.4-9.2 27.5s-22.4 1-27.5-9.2l-24.2-48.4-114.1 0-24.2 48.4c-5.1 10.1-17.4 14.2-27.5 9.2s-14.2-17.4-9.2-27.5l29.7-59.3c.1-.3 .3-.5 .4-.8l69.5-139c3.5-6.9 10.6-11.3 18.3-11.3zM294 349.9l73.1 0-36.6-73.1L294 349.9z"
  ]
};

// Custom Cards Blank icon (duotone) - extracted from Font Awesome Kit
export const faCardsBlank: IconDefinition = {
  prefix: "fas",
  iconName: "cards-blank" as any,
  icon: [
    512,
    512,
    [],
    "e055",
    "M285.4 104.5c1.1-.1 2.2-.1 3.4-.1l178.6 .1c24.7 0 44.6 20 44.7 44.6l0 267.1c0 24.6-20 44.6-44.7 44.6l-195.7 0c-6.3 0-12.2-1.3-17.6-3.6l63.6-34.8 149.7 0c3.4 0 6.1-2.8 6.2-6.2l0-267.2c0-3.4-2.8-6.1-6.2-6.1l-158.6 0-23.4-38.4zm-243.8 75c-3 1.7-3.9 5.4-2.2 8.4l134 231.4c1.7 3 5.5 3.9 8.4 2.2l154.7-89.1c3-1.7 3.9-5.4 2.2-8.4L204.7 92.6c-1.7-3-5.5-3.9-8.4-2.2L41.5 179.5zM6 207.1C-6.3 185.8 1 158.6 22.4 146.2L177 57.2c21.3-12.3 48.7-5 61 16.3L372 305c12.4 21.3 5 48.6-16.4 60.9l-154.7 89c-21.3 12.3-48.7 5-61-16.3L6 207.1z"
  ]
};

// Custom Cards Blank icon (regular) - same as duotone for this custom icon
export const farCardsBlank: IconDefinition = {
  prefix: "far",
  iconName: "cards-blank" as any,
  icon: [
    512,
    512,
    [],
    "e055",
    "M285.4 104.5c1.1-.1 2.2-.1 3.4-.1l178.6 .1c24.7 0 44.6 20 44.7 44.6l0 267.1c0 24.6-20 44.6-44.7 44.6l-195.7 0c-6.3 0-12.2-1.3-17.6-3.6l63.6-34.8 149.7 0c3.4 0 6.1-2.8 6.2-6.2l0-267.2c0-3.4-2.8-6.1-6.2-6.1l-158.6 0-23.4-38.4zm-243.8 75c-3 1.7-3.9 5.4-2.2 8.4l134 231.4c1.7 3 5.5 3.9 8.4 2.2l154.7-89.1c3-1.7 3.9-5.4 2.2-8.4L204.7 92.6c-1.7-3-5.5-3.9-8.4-2.2L41.5 179.5zM6 207.1C-6.3 185.8 1 158.6 22.4 146.2L177 57.2c21.3-12.3 48.7-5 61 16.3L372 305c12.4 21.3 5 48.6-16.4 60.9l-154.7 89c-21.3 12.3-48.7 5-61-16.3L6 207.1z"
  ]
};
